import { CardBody, Card, Row, Col } from 'reactstrap';
import CurrencyFormat from 'react-number-format';
import Tooltip from 'react-tooltip-lite';
import Icon from '../../../assets/icons/Icon';
import ContentLoader from '../../../components/ContentLoader';
import { useEffect } from 'react';
import { useDict } from '../../../contexts/LanguageContext';

const TotalIncome = (props) => {
    const { totalIncome, isLoading } = props;

    const dict = useDict();

    if (isLoading) {
        return (
            <ContentLoader width="100%" height="265" topBottom>
                <rect width="100%" height="100%" y="0" rx="10" ry="10" />
            </ContentLoader>
        );
    }
    return (
        <Card className="grid card-total-income margin-bottom-10">
            <CardBody style={{ textAlign: 'left' }}>
                <h5
                    style={{
                        color: '#1124A6',
                        fontWeight: 'bold',
                        marginLeft: '20px',
                    }}
                >
                    {dict.totalIncome}
                </h5>
                <Row style={{ margin: '15px 0 0 0' }}>
                    <Col md={5} xs={7} style={{ fontWeight: 'bold' }}>
                        {dict.profitReceived}&nbsp;
                        <Tooltip
                            content={dict.actualInterestReceived}
                            styles={{ display: 'inline' }}
                            distance={5}
                            arrowSize={8}
                        >
                            <Icon icon="InfoCircle" inline width="11" />
                        </Tooltip>
                    </Col>
                    <Col md={7} xs={5} style={{ textAlign: 'right' }}>
                        <CurrencyFormat
                            value={parseFloat(
                                totalIncome?.['profit_return'] ?? 0
                            ).toFixed(2)}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    </Col>
                </Row>
                {/* <Row style={{ margin: '0' }}>
                    <Col md={5} xs={7}>
                        + Late Profit&nbsp;
                        <Tooltip
                            content="Actual late interest received  when the tenure of the note exceeds the time stated"
                            styles={{ display: 'inline' }}
                            distance={5}
                            arrowSize={8}
                        >
                            <Icon icon="InfoCircle" inline width="11" />
                        </Tooltip>
                    </Col>
                    <Col md={7} xs={5} style={{ textAlign: 'right' }}>
                        <CurrencyFormat
                            value={parseFloat(totalIncome?.lateProfit ?? 0).toFixed(
                                2
                            )}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    </Col>
                </Row>

                <Row style={{ margin: '0px' }}>
                    <Col md={5} xs={7}>
                        + Other Income
                    </Col>
                    <Col md={7} xs={5} style={{ textAlign: 'right' }}>
                        <CurrencyFormat
                            value={parseFloat(totalIncome?.otherIncome ?? 0).toFixed(
                                2
                            )}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    </Col>
                </Row> */}
                <Row style={{ margin: '0px' }}>
                    <Col md={5} xs={7}>
                        - {dict.serviceFees}
                    </Col>
                    <Col md={7} xs={5} style={{ textAlign: 'right' }} className="fee-text">
                        <CurrencyFormat
                            value={parseFloat(
                                totalIncome?.['service_fee'] ?? 0
                            ).toFixed(2)}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    </Col>
                </Row>
                {/* <Row style={{ margin: '12px 0 0 0' }}>
                    <Col md={5} xs={7} style={{ fontWeight: 'bold' }}>
                        Net Return
                    </Col>
                    <Col md={7} xs={5} style={{ textAlign: 'right' }}>
                        <CurrencyFormat
                            value={parseFloat(totalIncome?.['net_return'] ?? 0).toFixed(2)}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    </Col>
                </Row> */}
                {/* <Row style={{ margin: '0px' }}>
                    <Col md={5} xs={7}>
                        - Defaults
                    </Col>
                    <Col md={7} xs={5} style={{ textAlign: 'right' }} className="fee-text">
                        <CurrencyFormat
                            value={parseFloat(totalIncome?.defaults ?? 0).toFixed(2)}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    </Col>
                </Row>
                <Row style={{ margin: '0px' }}>
                    <Col md={5} xs={7}>
                        + Recoveries&nbsp;
                        <Tooltip
                            content="Principal and interest, if any, of the previous defaulted investment notes"
                            styles={{ display: 'inline' }}
                            distance={5}
                            arrowSize={8}
                        >
                            <Icon icon="InfoCircle" inline width="11" />
                        </Tooltip>
                    </Col>
                    <Col md={7} xs={5} style={{ textAlign: 'right' }}>
                        <CurrencyFormat
                            value={parseFloat(totalIncome?.recoveries ?? 0).toFixed(
                                2
                            )}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    </Col>
                </Row> */}
                <Row
                    style={{
                        margin: '5px 0 0 0',
                        fontWeight: 'bold',
                        background: 'linear-gradient(90deg, #F29525, #F4BE23)',
                        color: 'white',
                    }}
                >
                    <Col
                        md={5}
                        xs={7}
                        style={{ height: '30px', paddingTop: '5px' }}
                    >
                        {dict.netReturn}
                    </Col>
                    <Col
                        md={7}
                        xs={5}
                        style={{
                            height: '30px',
                            paddingTop: '5px',
                            textAlign: 'right',
                        }}
                    >
                        <CurrencyFormat
                            value={parseFloat(totalIncome?.['net_return'] ?? 0).toFixed(2)}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default TotalIncome;
